export default {
  listInternShip(params) {
    return Request.get('api/top/intern_ship/client', params);
  },
  listIInfoIntern(params) {
    return Request.get('api/top/info_intern/client', params);
  },
  listIntern(params) {
    return Request.get('api/top/intern/client', params);
  },
  listVideo(params) {
    return Request.get('api/top/video/client', params);
  },
  list(params) {
    return Request.get('api/top', params);
  },
  listItem(params) {
    return Request.get('api/top/item/client', params);
  },
  show(id) {
    return Request.get(`api/top/${id}`);
  },
};
